import { triggerFileDownloadDialog } from '../../helpers/public-helpers';

// inspiration/ sources:
// - https://gist.github.com/sators/2c2578018c1aa1f7fedececc39658f17
// - https://gist.github.com/select/0e2aa49b98ea81db7c615e6560497c41
export const transformObjectsToCsv = (data: any[], lineSeperator = '\n', columnSeperator = ';') => {
    let result: string;

    if (!data.length) {
        return '';
    }

    const keys = Object.keys(data[0]);

    result = '';
    result = `${result}${keys.join(columnSeperator)}`;
    result = `${result}${lineSeperator}`;

    data.forEach((item: any) => {
        let i = 0;
        keys.forEach((key) => {
            if (i > 0) {
                result = `${result}${columnSeperator}`;
            }

            let value = item[key];

            // escape if necessary
            if (
                typeof value === 'string' &&
                (value.includes(columnSeperator) ||
                    value.replace(/ /g, '').match(/[\s,"]/) ||
                    value.replace(/ /g, '').match(/\n/))
            ) {
                value = `"${value.replace(/"/g, '""')}"`;
            }

            result = `${result}${value}`;
            i++;
        });
        result = `${result}${lineSeperator}`;
    });

    return result;
};

export const downloadCsvFile = (data: string, filename: string) => {
    // explaination "\uFEFF" see issue: https://github.com/eligrey/FileSaver.js/issues/28#issue-15333709
    // (used to tell excel it's utf-8 in order to display special characters correctly)
    triggerFileDownloadDialog(`\uFEFF${data}`, 'text/csv;charset=utf-8', `${filename}.csv`);
};
